/**
 * @module js/desNavigateContentAsListDefaultService
 */
import eventBus from 'js/eventBus';

export const refreshViewModel = (viewModel) => {
    const { data, dispatch } = viewModel;
    data.selectedLibraryId.dbValue = null;
    data.selectedFolderId.dbValue = null;
    data.dynamicCrumbs = [];
    data.skip = 0;
    data.searchBox.dbValue = null;

    // update state (i.e data in afx-next-react)
    dispatch({ path: 'data', value: { ...data } });
};

export const resetSkipVals = (viewModel) => {
    const { data, dispatch } = viewModel;
    data.skip = 0;
    dispatch({ path: 'data.skip', value: 0 });
};

export const manageListCellSelection = (viewModel, selectedObjects) => {
    if (selectedObjects.length > 0) {
        const selectedObject = selectedObjects[0];
        const { data, dispatch } = viewModel;
        if (selectedObject.containerType === 'library' || selectedObject.containerType === 'project' || selectedObject.containerType === 'Folder') {
            const crumbCount = data.dynamicCrumbs.length;
            if (crumbCount >= 1) {
                data.dynamicCrumbs[crumbCount - 1].selectedCrumb = false;
            }
            const crumb = {
                clicked: false,
                displayName: selectedObject.cellHeader1,
                selectedCrumb: true,
                showArrow: true,
                cellType: selectedObject.containerType,
                relUID: selectedObject.containerId
            };
            crumb.onCrumbClick = function (selectedCrumb, event) {
                // onclick publish event with crumbindex and selectedCrumb
                eventBus.publish('NavigateContentsAsList.breadCrumbSelected', { crumbIndex: crumbCount, crumb: selectedCrumb });
            };
            // add createdCrumb to dynamicCrumbs field
            data.dynamicCrumbs = [...data.dynamicCrumbs, crumb];

            // if project or library clicked set
            if (selectedObject.containerType === 'library' || selectedObject.containerType === 'project') {
                data.selectedLibraryId.dbValue = selectedObject.containerId;
            } else if (selectedObject.cellType === 'Folder') {
                data.selectedFolderId.dbValue = selectedObject.containerId;
            }
            // reset search value when library or project or folder clicked.
            data.searchBox.dbValue = null;
        }

        // update state (i.e data in afx-next-react)
        dispatch({ path: 'data', value: { ...data } });
    }
};

export const manageCrumbSelection = (viewModel, crumbIndex) => {
    const { data, dispatch } = viewModel;

    data.dynamicCrumbs = data.dynamicCrumbs.slice(0, crumbIndex + 1);
    data.dynamicCrumbs[crumbIndex].selectedCrumb = true;

    if (data.dynamicCrumbs[crumbIndex].cellType === 'library' || data.dynamicCrumbs[crumbIndex].cellType === 'project') {
        data.selectedFolderId.dbValue = null;
    } else if (data.dynamicCrumbs[crumbIndex].cellType === 'Folder') {
        data.selectedFolderId.dbValue = data.dynamicCrumbs[crumbIndex].relUID;
    }

    data.searchBox.dbValue = null;
    dispatch({ path: 'data', value: { ...data } });
};


export default {
    refreshViewModel,
    resetSkipVals,
    manageListCellSelection,
    manageCrumbSelection
}
